// extracted by mini-css-extract-plugin
export default {"overflow-hidden":"add-card-modal_overflow-hidden__lfKII"};